import { gql } from '@apollo/client';

// Tier options for one cart item's subscription disclosure at checkout,
// resolved server-side with the same price book the acknowledgment records.
// The customer app splits them per item (see splitTiers in acknowledgmentCopy.js).
export default gql`
  query cartItemSubscriptionTiers($cartItemId: ID!) {
    cartItemSubscriptionTiers(cartItemId: $cartItemId) {
      price
      overPrice
      units
      product {
        id
        name
        description
        price
        productType
        renewalIntervalMonths
      }
    }
  }
`;
